import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  FaRobot,
  FaUser,
  FaSearch,
  FaExclamationCircle,
  FaUserTie,
  FaExclamationTriangle,
  FaBan
} from "react-icons/fa";
import "../../css/HistorialChats.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EmojiPicker from "emoji-picker-react";


const API_BASE = "https://localhost:7126/api/Chat";

const formatPrettyDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();

  const isSameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);

  const timeOptions = { hour: "numeric", minute: "2-digit" };

  if (isSameDay(d, now)) return `Hoy ${d.toLocaleTimeString([], timeOptions)}`;
  if (isSameDay(d, yesterday))
    return `Ayer ${d.toLocaleTimeString([], timeOptions)}`;

  // ej: 12 Oct 2025 4:25 PM
  return d.toLocaleString([], {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

const HistorialChats = () => {
  const [chats, setChats] = useState([]); // raw data from API
  const [selectedSession, setSelectedSession] = useState(null);
  const [query, setQuery] = useState("");
  const [messageText, setMessageText] = useState(""); // Mensaje Input
  const [loading, setLoading] = useState(false);
  const [spamMap, setSpamMap] = useState({}); // { numero spam: true/false }
  const [spamMotivos, setSpamMotivos] = useState({});
  const [transferenciaMap, setTransferenciaMap] = useState({});
  const [transferenciaMotivos, setTransferenciaMotivos] = useState({});
  const [tarjetaMap, setTarjetaMap] = useState({});
  const [tarjetaMotivos, setTarjetaMotivos] = useState({});

  const [showPicker, setShowPicker] = useState(false); //Ver Emojis Panel
  const [estadoBtonEnviarMensaje, setEstadoBtonEnviarMensaje] = useState(false); //Ver Emojis Panel
  const [filtroEtiqueta, setFiltroEtiqueta] = useState("todos");


  // refs for scroll
  const leftListRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const firstLoad = useRef(false);


  // Obtener el historial de  chats
const ObtenerHistorialChats = async (silent = false) => {
  if (!silent) setLoading(true);

  try {
    const res = await axios.get(`${API_BASE}/ObtenerChats`);

    const normalized = Array.isArray(res.data)
      ? res.data.map((c) => {
          let numero = c.sessionId.split("@")[0].split(":")[0];

          return {
            sessionId: numero,
            nombreWhatsapp: c.nombreWhatsapp,
            telefonoWhatsapp: c.telefonoWhatsapp,
            mensajes: (c.mensajes || []).map((m) => ({
              id: m.id,
              content: m.mensaje,
              fechaRegistro: m.fechaMensaje,
              fromAgent:
                m.origen === "Agente IA"
                  ? "ai"
                  : m.origen === "Asesor"
                  ? "system"
                  : "human",
              estado: m.estado,
            })),
          };
        })
      : [];

    const grouped = normalized.reduce((acc, chat) => {
      if (!acc[chat.sessionId]) {
        acc[chat.sessionId] = {
          sessionId: chat.sessionId,
          nombreWhatsapp: chat.nombreWhatsapp,
          telefonoWhatsapp: chat.telefonoWhatsapp,
          mensajes: [],
        };
      }
      acc[chat.sessionId].mensajes = chat.mensajes;
      return acc;
    }, {});

    const chatsArray = Object.values(grouped);

    setChats(chatsArray);

    // NO cambiar el chat seleccionado
    if (
      !selectedSession &&
      chatsArray.length > 0
    ) {
      setSelectedSession(chatsArray[0].sessionId);
    }
  } catch (err) {
    console.error("Auto-refresh error", err);
  } finally {
    if (!silent) setLoading(false);
  }
};


// Actualizar mensajes automaticamente
useEffect(() => {
  const interval = setInterval(() => {
      if (document.activeElement === inputRef.current) return;  //SI eesta escribiendo NO Actualizar
    // refresco silencioso
    ObtenerHistorialChats(true);
  }, 5000); // ⏱ cada 5 segundos (ajusta a gusto)

  return () => clearInterval(interval); // limpieza
}, [selectedSession]);



  // Funcion para validar si es spam o no
  const validarSpam = async (numero) => {
    try {
      const res = await axios.get(`${API_BASE}/ValidarTelefonoSpam/${numero}`);

      if (res.data && res.data.estado === true) {
        setSpamMap((prev) => ({ ...prev, [numero]: true }));
        setSpamMotivos((prev) => ({ ...prev, [numero]: res.data.motivo }));
      } else {
        setSpamMap((prev) => ({ ...prev, [numero]: false }));
      }
    } catch (err) {
      console.error("Error validando spam", err);
    }
  };

  // Funcion para validar si es transferencia a humano
  const validarTransferenciaHumano = async (numero) => {
    try {
      const res = await axios.get(
        `${API_BASE}/ValidarTelefonoTransferencia/${numero}`
      );

      if (res.data && res.data.estado === true) {
        setTransferenciaMap((prev) => ({ ...prev, [numero]: true }));
        setTransferenciaMotivos((prev) => ({
          ...prev,
          [numero]: res.data.mensajeTransferencia,
        }));
      } else {
        setTransferenciaMap((prev) => ({ ...prev, [numero]: false }));
      }
    } catch (err) {
      console.error("Error validando transferencia", err);
    }
  };

  // Funcion para validar si esta interesado en tarjeta
  const validarInteresTarjeta = async (numero) => {
    try {
      const res = await axios.get(
        `${API_BASE}/ValidarInteresadoTarjeta/${numero}`
      );

      if (res.data && res.data.procesado === false) {
        setTarjetaMap((prev) => ({ ...prev, [numero]: true }));
        setTarjetaMotivos((prev) => ({ ...prev, [numero]: res.data.mensaje }));
      } else {
        setTarjetaMap((prev) => ({ ...prev, [numero]: false }));
      }
    } catch (err) {
      console.error("Error validando transferencia", err);
    }
  };


  // Tomar Control de un Chat ya se la IA o un Asesor
  const tomarControl = async () => {
    if (!selectedSession) return;

    try {
      const payload = {
        numeroTelefono: selectedSession,
        motivoTransferencia: "Control tomado por asesor",
        usuarioRegistro: "asesor-web",  // <- cámbialo según tu lógica
        usuarioModificacion: "asesor-web"  // <- cámbialo según tu lógica
      };

      let res;

      // Si YA está en modo asesor → devolver control a la IA
      if (transferenciaMap[selectedSession] === true) {
        res = await axios.post(`${API_BASE}/TomarControlIAWhatsApp`, payload);

        // Actualiza flags en el frontend
        setTransferenciaMap((prev) => ({ ...prev, [selectedSession]: false }));
      }
      // Si NO está en modo asesor → tomar control humano
      else {
        res = await axios.post(`${API_BASE}/TomarControlAsesorWhatsApp`, payload);

        // Actualiza flags en el frontend
        setTransferenciaMap((prev) => ({ ...prev, [selectedSession]: true }));

        validarTransferenciaHumano(selectedSession);
      }

      console.log("Respuesta:", res.data);
    } catch (err) {
      console.error("❌ Error al tomar control:", err);
    }
  };


  // Elminar SPAM de un Numero
  const eliminarSPAM = async () => {
    if (!selectedSession) return;

    try {
      const payload = {
        numeroTelefono: selectedSession,
        usuarioModificacion: "asesor-web"  // <- cámbialo según tu lógica
      };

      let res;

      res = await axios.post(`${API_BASE}/EliminarTelefonoDeSpam`, payload);

      // Actualiza flags en el frontend
      setSpamMap((prev) => ({ ...prev, [selectedSession]: false }));
      validarSpam(selectedSession);

      console.log("Respuesta:", res.data);
    } catch (err) {
      console.error("❌ Error al tomar control:", err);
    }
  };


  // Marcar como SPAM
  const marcarComoSPAM = async () => {
    if (!selectedSession) return;

    try {
      const payload = {
        numeroTelefono: selectedSession,
        motivoSpam: "Asesor marca como SPAM",
        usuarioRegistro: "asesor-web" // cámbialo si usas cookies o usuario logueado
      };

      const res = await axios.post(`${API_BASE}/InsertarTelefonoSpam`, payload);

      // Actualizar flags en el frontend
      setSpamMap((prev) => ({ ...prev, [selectedSession]: true }));
      validarSpam(selectedSession);

      console.log("Respuesta:", res.data);
    } catch (err) {
      console.error("❌ Error al marcar como SPAM:", err);
    }
  };


  // Cada vez que hay un autoposback
  useEffect(() => {
    if (firstLoad.current) return;
    firstLoad.current = true;

    ObtenerHistorialChats();
  }, []);


  // Filtra en todas las coversaciones las coincidencias segun los filtros indicados 
  const filtrarChats = chats.filter(chat => {
    // --- FILTRO POR ETIQUETA ---
    if (filtroEtiqueta !== "todos") {
      if (filtroEtiqueta === "spam" && !spamMap[chat.sessionId]) return false;
      if (filtroEtiqueta === "asesor" && !transferenciaMap[chat.sessionId]) return false;
      if (filtroEtiqueta === "tarjeta" && !tarjetaMap[chat.sessionId]) return false;
    }

    // --- FILTRO POR BUSCADOR ---
    if (query.trim()) {
      const q = query.trim().toLowerCase();

      const lastMsg = chat.mensajes?.length
        ? chat.mensajes[chat.mensajes.length - 1].content.toLowerCase()
        : "";
      const number = chat.sessionId.toLowerCase();
      if (!number.includes(q) && !lastMsg.includes(q)) return false;
    }

    return true;
  });

  // Cuanso se aplique un filtro de chat validar si el que esta seleccionado se encuentra en el historial de busqueda
  // o se deja seleccioando por defecto el primero que encuentra
  useEffect(() => {
    if (!filtrarChats.length) {
      // No hay chats en el filtro → deseleccionar
      setSelectedSession(null);
      return;
    }

    // Si el chat seleccionado no está en la lista filtrada → cambiarlo
    const existe = filtrarChats.some(
      (chat) => chat.sessionId === selectedSession
    );

    if (!existe) {
      setSelectedSession(filtrarChats[0].sessionId);
    }
  }, [filtrarChats]);



  // auto-scroll to bottom when selectedSession or chats change
  useEffect(() => {
    const el = messagesContainerRef.current;
    if (!el) return;
    // small delay to ensure DOM updated
    const t = setTimeout(() => {
      el.scrollTop = el.scrollHeight;
    }, 60);
    return () => clearTimeout(t);
  }, [selectedSession, chats]);

  // helper to add a local message (optimistic)
  const addLocalMessage = (sessionId, msg) => {
    setChats((prev) => {
      // find chat
      const found = prev.find((c) => c.sessionId === sessionId);
      if (found) {
        return prev.map((c) =>
          c.sessionId === sessionId
            ? { ...c, mensajes: [...c.mensajes, msg] }
            : c
        );
      } else {
        // create new conversation
        return [...prev, { sessionId, mensajes: [msg] }];
      }
    });
  };
  const inputRef = useRef(null);


  // Función para agregar emoji al texto
  const onEmojiClick = (emojiData, event) => {
    const input = inputRef.current;
    if (!input) return; // <--- Evita el error si input es null

    const start = input.selectionStart;
    const end = input.selectionEnd;

    const newText =
      messageText.substring(0, start) +
      emojiData.emoji +
      messageText.substring(end);

    setMessageText(newText);

    // Colocar cursor después del emoji insertado
    setTimeout(() => {
      input.focus();
      input.setSelectionRange(
        start + emojiData.emoji.length,
        start + emojiData.emoji.length
      );
    }, 0);

    setShowPicker(false); // Oculta panel después de seleccionar
  };


  // Función para enviar un mensaje desde el agente
  const EnviarMensajeWhat = async () => {
    // 1. Quitamos espacios y validamos que haya texto y chat seleccionado
    const text = messageText.trim();
    if (!text || !selectedSession) return;

    // 2. Creamos un ID temporal para el mensaje mientras se envía al backend
    //    Esto permite a React identificarlo y actualizar su estado después.
    const tempId = `temp-${Date.now()}`;

    // 3. Creamos el mensaje local que se mostrará en pantalla de inmediato.
    //    __status controla cómo se va a mostrar (pending, sent, error)
    const newMsg = {
      fromAgent: "system", // Lo ubica a la derecha en el chat
      content: messageText, // Texto real del mensaje
      fechaRegistro: new Date().toISOString(), // Hora local del front
      __tempId: tempId, // ID temporal mientras se envía
      __status: "pending", // Estado visual: "pendiente de enviar"
    };

    // 4. Agregamos el mensaje inmediatamente en el chat sin esperar API
    //    Esto hace que se vea instantáneo (igual que WhatsApp Web)
    addLocalMessage(selectedSession, newMsg);

    // 5. Limpiamos la caja de texto
    setMessageText("");

    try {
      // 6. Llamamos al backend para enviar el mensaje real por WhatsApp
      await axios.post(`${API_BASE}/EnviarMensajeWhatsApp`, {
        telefono: selectedSession, // Número de la sesión
        mensaje: messageText, // Puede incluir emojis 🌟🔥💬
      });

      // 7. Si el backend responde OK → marcamos el mensaje como enviado
      setChats((prev) =>
        prev.map((c) => {
          if (c.sessionId !== selectedSession) return c;

          return {
            ...c,
            mensajes: c.mensajes.map((m) =>
              m.__tempId === tempId
                ? { ...m, __status: "sent", __tempId: undefined } // éxito
                : m
            ),
          };
        })
      );
    } catch (err) {
      console.error("Error al enviar mensaje", err);

      // 8. Si la API falla → marcamos el mensaje como ERROR
      //    Esto permite que en la UI se muestre un botón "Reintentar"
      setChats((prev) =>
        prev.map((c) => {
          if (c.sessionId !== selectedSession) return c;

          return {
            ...c,
            mensajes: c.mensajes.map((m) =>
              m.__tempId === tempId
                ? { ...m, __status: "error" } // Marcado como fallido
                : m
            ),
          };
        })
      );
    }
  };

  // utility to display last message preview
  const lastPreview = (chat) => {
    const last =
      chat.mensajes && chat.mensajes.length
        ? chat.mensajes[chat.mensajes.length - 1].content
        : "";
    return last.length > 40 ? last.slice(0, 40) + "..." : last;
  };


  const chatsFiltrados = chats.filter(c => {
    if (filtroEtiqueta === "todos") return true;
    if (filtroEtiqueta === "spam") return spamMap[c.sessionId] === true;
    if (filtroEtiqueta === "asesor") return transferenciaMap[c.sessionId] === true;
    if (filtroEtiqueta === "tarjeta") return tarjetaMap[c.sessionId] === true;

    return true;
  });


  // render
  return (
    <div className="card card-success card-outline" style={{ height: "85vh" }}>
      <div className="card-header d-flex align-items-center">
        <h3 className="card-title" tyle={{ fontWeight: "bold" }} >Historial de Chats</h3>
        <div className="ml-auto d-flex align-items-center" style={{ gap: 8 }}>

          {/* 🔽 FILTRO POR ETIQUETAS */}
          <select
            className="form-control form-control-sm"
            style={{ width: 180 }}
            value={filtroEtiqueta}
            onChange={(e) => setFiltroEtiqueta(e.target.value)}
          >
            <option value="todos">Todas las etiquetas</option>
            <option value="spam">Spam</option>
            <option value="asesor">Transferidos a asesor</option>
            <option value="tarjeta">Interesados tarjeta</option>
          </select>


          <div className="input-group input-group-sm" style={{ width: 320 }}>
            <div className="input-group-prepend">
              <span className="input-group-text">
                <FaSearch />
              </span>
            </div>
            <input
              className="form-control"
              placeholder="Buscar chats por número o texto..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
          <button
            className="btn btn-tool"
            onClick={ObtenerHistorialChats}
            title="Actualizar"
          >
            <i className="fas fa-sync-alt" />
          </button>
        </div>
      </div>

      <div className="card-body p-0" style={{ height: "calc(100% - 56px)" }}>
        <div className="row m-0" style={{ height: "100%" }}>
          {/* LEFT: lista de conversaciones */}
          <div
            className="col-4 border-right p-0"
            style={{ height: "100%", overflowY: "auto" }}
            ref={leftListRef}
          >
            {loading && (
              <div className="p-3 text-muted">Cargando conversaciones...</div>
            )}

            {filtrarChats.map((chat) => {
              const last =
                chat.mensajes && chat.mensajes.length
                  ? chat.mensajes[chat.mensajes.length - 1]
                  : null;
              return (
                <div


                  key={chat.sessionId}
                  className={`p-3 d-flex align-items-start chat-list-item ${selectedSession === chat.sessionId ? "selected-chat" : ""
                    }`}
                  style={{ cursor: "pointer", borderBottom: "1px solid #eee" }}
                  onClick={() => setSelectedSession(chat.sessionId)}
                >
                  <div
                    style={{
                      width: 46,
                      height: 46,
                      borderRadius: 46,
                      background: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: 12,
                    }}
                  >
                    {/* avatar: según el tipo de mensaje */}
                    {last && last.fromAgent === "ai" ? (
                      <FaRobot size={18} />
                    ) : last && last.fromAgent === "system" ? (
                      <FaUserTie size={18} />     // o cualquier icono de asesor
                    ) : (
                      <FaUser size={18} />        // humano
                    )}

                  </div>
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          padding: "2px 0",
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          {/* Nombre */}
                          <span
                            style={{
                              fontSize: 15,
                              fontWeight: 600,
                              color: "#1f2937", // gris oscuro elegante
                              lineHeight: "1.1",
                            }}
                          >
                            {chat.nombreWhatsapp || "Contacto sin nombre"}
                          </span>

                          {/* Número */}
                          <span
                            style={{
                              fontSize: 12,
                              color: "#6b7280", // gris suave
                              marginTop: 2,
                            }}
                          >
                            {chat.telefonoWhatsapp || chat.sessionId}
                          </span>
                        </div>


                        {/* --- BADGE SPAM --- */}
                        {spamMap[chat.sessionId] && (
                          <span
                            onClick={() => {
                              toast.error(
                                spamMotivos[chat.sessionId] ||
                                "Sin motivo registrado",
                                {
                                  position: "top-right",
                                  autoClose: 4000,
                                  theme: "colored",
                                }
                              );
                            }}
                            style={{
                              background: "#ff4d4f",
                              padding: "3px 10px",
                              borderRadius: "50px",
                              fontSize: "11px",
                              fontWeight: "bold",
                              color: "white",
                              boxShadow: "0 0 4px rgba(255, 77, 79, 0.4)",
                              border: "1px solid rgba(255,255,255,0.4)",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              cursor: "pointer",
                              //animation: "pulse 1.7s infinite",
                            }}
                          >
                            ⚠️ SPAM
                          </span>
                        )}

                        {/* --- BADGE TRANSFERENCIA A HUMANO --- */}
                        {transferenciaMap[chat.sessionId] && (
                          <span
                            onClick={() => {
                              toast.info(
                                transferenciaMotivos[chat.sessionId] ||
                                "Sin motivo registrado",
                                {
                                  position: "top-right",
                                  autoClose: 4000,
                                  theme: "colored",
                                }
                              );
                            }}
                            style={{
                              background: "#3498db",
                              padding: "3px 10px",
                              borderRadius: "50px",
                              fontSize: "11px",
                              fontWeight: "bold",
                              color: "white",
                              boxShadow: "0 0 4px rgba(52, 152, 219, 0.4)",
                              border: "1px solid rgba(255,255,255,0.4)",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              cursor: "pointer",
                              //animation: "pulse 1.7s infinite",
                            }}
                          >
                            👨‍💼 ASESOR
                          </span>
                        )}

                        {/* --- BADGE INTERÉS TARJETA (VERDE) --- */}
                        {tarjetaMap[chat.sessionId] && (
                          <span
                            onClick={() => {
                              toast.success(
                                tarjetaMotivos[chat.sessionId] ||
                                "Sin motivo registrado",
                                {
                                  position: "top-right",
                                  autoClose: 4000,
                                  theme: "colored",
                                }
                              );
                            }}
                            style={{
                              background: "#1abc9c",
                              padding: "3px 10px",
                              borderRadius: "50px",
                              fontSize: "11px",
                              fontWeight: "bold",
                              color: "white",
                              boxShadow: "0 0 6px rgba(26, 188, 156, 0.7)",
                              border: "1px solid rgba(255,255,255,0.4)",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              cursor: "pointer",
                              //animation: "pulse 1.7s infinite",
                            }}
                          >
                            💳 INTERÉS TARJETA
                          </span>
                        )}

                        <style>
                          {`
                              @keyframes pulse {
                                0% { transform: scale(1); }
                                50% { transform: scale(1.08); }
                                100% { transform: scale(1); }
                              }
                          `}
                        </style>

                        <ToastContainer />
                      </div>

                      <small className="text-muted">
                        {last ? formatPrettyDate(last.fechaRegistro) : ""}
                      </small>
                    </div>
                    <div
                      className="text-muted"
                      style={{ marginTop: 0, fontSize: 13 }}
                    >
                      {lastPreview(chat)}
                    </div>
                  </div>
                </div>
              );
            })}

            {filtrarChats.length === 0 && !loading && (
              <div className="p-3 text-muted">No hay conversaciones.</div>
            )}
          </div>

          {/* RIGHT: chat */}
          <div
            className="col-8 p-0 d-flex flex-column"
            style={{
              height: "100%",
              backgroundImage:
                "url('https://media.istockphoto.com/id/1201667381/es/vector/soporte-al-cliente-relacionado-patr%C3%B3n-sin-costuras-y-fondo-con-iconos-de-l%C3%ADnea.jpg?s=612x612&w=0&k=20&c=vlC_7TnvXF1ERqX1sJZJGu1K4-xdEBKr-1BW2VDwuGE=')",
              backgroundRepeat: "repeat",
              backgroundSize: "60%",
              backgroundColor: "rgba(255, 255, 255, 0.7)", // Blanco con opacidad
              backgroundBlendMode: "lighten", // Cambia a "darken" si usas fondo oscuro
            }}
          >

            {/* header */}
            <div
              className="p-3 border-bottom bg-white d-flex align-items-center"
              style={{ minHeight: 60 }}
            >
              {selectedSession ? (
                <>
                  <div
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 48,
                      background: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: 12,
                    }}
                  >
                    <FaUser />
                  </div>

                  {/* datos del usuario */}
                  <div>
                    <strong>{selectedSession}</strong>
                    <div className="text-muted" style={{ fontSize: 12 }}>
                      {(() => {
                        const chat = chats.find(
                          (c) => c.sessionId === selectedSession
                        );
                        const last =
                          chat && chat.mensajes.length
                            ? chat.mensajes[chat.mensajes.length - 1]
                            : null;
                        return last
                          ? formatPrettyDate(last.fechaRegistro)
                          : "Sin actividad";
                      })()}
                    </div>
                  </div>


                  <button
                    className="d-flex align-items-right"
                    onClick={spamMap[selectedSession] ? eliminarSPAM : marcarComoSPAM}
                    style={{
                      marginLeft: "auto",
                      backgroundColor: "rgb(232, 234, 246)",
                      color: "#000",
                      border: "none",
                      padding: "8px 16px",
                      borderRadius: "20px",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                      transition: "all 0.2s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "rgba(232, 234, 246, 0.78)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "rgb(232, 234, 246)";
                    }}
                  >
                    {/* Si YA está en modo asesor → mostrar IA */}
                    {spamMap[selectedSession] === true ? (
                      <>
                        <FaBan />
                        Eliminar Spam
                      </>
                    ) : (
                      /* Si NO está en asesor → permitir tomar control */
                      <>
                        <FaExclamationTriangle />
                        Marcar como Spam
                      </>
                    )}


                  </button>



                  {/* Botón Tomar Control Asesor/ Tomar Control IA */}
                  <button
                    className="d-flex align-items-right"
                    onClick={tomarControl}
                    style={{
                      marginLeft: "20px",
                      backgroundColor:
                        transferenciaMap[selectedSession] ? "rgb(232, 234, 246)" : "rgb(232, 234, 246)",
                      color: "#000",
                      border: "none",
                      padding: "8px 16px",
                      borderRadius: "20px",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                      transition: "all 0.2s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor =
                        transferenciaMap[selectedSession] ? "rgba(232, 234, 246, 0.78)" : "rgba(232, 234, 246, 0.78)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor =
                        transferenciaMap[selectedSession] ? "rgb(232, 234, 246)" : "rgb(232, 234, 246)";
                    }}
                  >

                    {/* Si YA está en modo asesor → mostrar IA */}
                    {transferenciaMap[selectedSession] === true ? (
                      <>
                        <FaRobot />
                        Asignar IA
                      </>
                    ) : (
                      /* Si NO está en asesor → permitir tomar control */
                      <>
                        <FaUserTie />
                        Tomar Control
                      </>
                    )}

                  </button>




                </>
              ) : (
                <div className="text-muted">Selecciona una conversación</div>
              )}
            </div>






            {/* Panel derecho - Historial */}
            {/* Historial de Chat */}
            <div
              ref={messagesContainerRef}
              className="p-3"
              style={{ flex: 1, overflowY: "auto" }}
            >
              {selectedSession ? (
                (
                  chats.find((c) => c.sessionId === selectedSession)?.mensajes || []
                ).map((msg, idx) => {

                  const from = msg.fromAgent;               // "ai" | "asesor" | "human"
                  const isAI = from === "ai";
                  const isAsesor = from === "system";
                  const isHuman = from === "human";
                  const alignRight = isAI || isAsesor;      // izquierda solo human

                  const renderAvatar = () => {
                    if (isAI) return <FaRobot />;
                    if (isAsesor) return <FaUserTie />;
                    return <FaUser />;
                  };

                  return (
                    <div
                      key={idx}
                      className={`d-flex mb-2 ${alignRight ? "justify-content-end" : "justify-content-start"
                        }`}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: alignRight ? "row-reverse" : "row",
                          alignItems: "flex-end",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            maxWidth: "72%",
                            background: isAI
                              ? "#dcf8c6"          // AI verde claro
                              : isAsesor
                                ? "#e8eaf6"          // Asesor azul muy suave
                                : "#fff",            // Human blanco
                            color: "#000",
                            padding: "10px 12px",
                            borderRadius: 12,
                            boxShadow: "0 1px 1px rgba(0,0,0,0.06)",
                            position: "relative",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              marginBottom: 6,
                            }}
                          >
                            {renderAvatar()}
                            <small className="text-muted" style={{ fontSize: 11 }}>
                              {formatPrettyDate(msg.fechaRegistro)}
                            </small>
                          </div>

                          <div style={{ whiteSpace: "pre-wrap" }}>{msg.content}</div>

                          {/* status */}
                          <div
                            style={{
                              marginTop: 6,
                              display: "flex",
                              justifyContent: alignRight ? "flex-end" : "flex-start",
                              gap: 8,
                            }}
                          >
                            {msg.__status === "pending" && (
                              <small className="text-muted">Enviando…</small>
                            )}
                            {msg.__status === "sent" && (
                              <small className="text-muted">Enviado</small>
                            )}
                            {msg.__status === "error" && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 6,
                                }}
                              >
                                <FaExclamationCircle color="#d9534f" />
                                <button className="btn btn-link p-0">Reintentar</button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="text-center text-muted mt-5">
                  Selecciona una conversación a la izquierda
                </div>
              )}
            </div>

            {/* Caja de texto Enviar Mensaje */}
            {selectedSession && (
              <div
                className="p-3 border-top bg-white"
                style={{ minHeight: 72 }}
              >
                <div className="d-flex" style={{ gap: 8 }}>
                  <input
                    ref={inputRef}
                    value={messageText}
                    onChange={(e) => setMessageText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") EnviarMensajeWhat();
                    }}
                    className="form-control"
                    disabled={transferenciaMap[selectedSession] == false}
                    placeholder="Escribe un mensaje y presiona Enter o Enviar..."
                  />

                  {/* Botón para abrir el picker */}
                  <button
                    className="btn btn-light"
                    onClick={() => setShowPicker((prev) => !prev)}
                    disabled={transferenciaMap[selectedSession] == false}
                  >
                    😄
                  </button>

                  <button
                    className="btn btn-success"
                    disabled={transferenciaMap[selectedSession] == false}
                    onClick={EnviarMensajeWhat}
                  >
                    Enviar
                  </button>
                </div>

                {/* Emoji picker */}
                {showPicker && (
                  <div
                    style={{ position: "absolute", bottom: 60, zIndex: 1000 }}
                  >
                    <EmojiPicker onEmojiClick={onEmojiClick} />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistorialChats;
